import { getHudDockTop } from '../utils/hudDockGeometry';
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './SpellAreaPreview.module.scss';

export default function SpellControlsBar({ label, hint, count, maximum, countLabel, actions, error, children }) {
  const [bottom, setBottom] = useState(12);
  useEffect(() => {
    const dock = document.querySelector('.combat-hud-dock') || document.querySelector('.zombies-dm-bottom-bar');
    const update = () => {
      const rect = dock?.getBoundingClientRect();
      const visible = rect && rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0;
      setBottom(visible ? Math.max(12, window.innerHeight - getHudDockTop(dock) + 12) : 12);
    };
    update();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(update);
    if (dock) observer?.observe(dock);
    window.addEventListener('resize', update);
    return () => { observer?.disconnect(); window.removeEventListener('resize', update); };
  }, []);
  return createPortal(<div className={styles.controls} role="status" style={{ bottom }}>
    {label && <div className={styles.summary}>
      <span className={styles.icon} aria-hidden="true">✦</span>
      <div><strong className={styles.title}>{label}</strong><span className={styles.hint}>{hint}</span></div>
      {maximum != null && <span className={styles.count} aria-label={countLabel}>{count}<span> / {maximum}</span></span>}
    </div>}
    {actions && <div className={styles.actions}>{actions}</div>}
    {children}
    {error && <div className={styles.error} role="alert">{error}</div>}
  </div>, document.body);
}
